<template>
  <form action="#" @submit.prevent="save">
    <rui-errors :errors="errors" />
    <rui-field input-id="comment_content"
               :label="$t('activerecord.attributes.comment.content')"
               :help="$t('js.comments.new_comment_disclaimer')"
               invisible-label>
      <textarea id="comment_content" v-model="inputs.content" name="comment_content" required />
    </rui-field>

    <div class="-mtd -text--right">
      <rui-submit-button :caption="$t('js.generic.send')" />
    </div>
  </form>
</template>

<script>
import RuiErrors from '@experiments-labs/rise_ui/src/components/DataDisplay/Error/Errors.vue'
import RuiField from '@experiments-labs/rise_ui/src/components/Form/Field.vue'
import RuiSubmitButton from '@experiments-labs/rise_ui/src/components/Inputs/SubmitButton/SubmitButton.vue'

import Comment from '../../../classes/models/Comment'

import Toaster from '../../../tools/Toaster'

/**
 * Form to write comments
 *
 * @preset default {}
 * @preset with_comment { "props": { "comment": { "id": 10, "content": "This is a comment" } } }
 */
export default {
  name: 'GpCommentForm',
  emits: ['saved'],
  components: { RuiSubmitButton, RuiErrors, RuiField },
  props: {
    /** Comment to edit; can be an existing `Comment`, an empty one, or an object that looks like a `Comment` */
    comment: { required: false, type: [Comment, Object], default: null },
  },
  data () {
    return {
      inputs: { ...this.fillInputs() },
      errors: null,
      loading: false,
    }
  },
  methods: {
    fillInputs () {
      return {
        id: null,
        content: '',
        observation_id: '',
        ...this.$props.comment,
      }
    },
    save () {
      const payload = { ...this.inputs }
      if (!payload.id) { delete payload.id }

      this.loading = true
      this.errors = null
      const call = payload.id ? Comment.update(payload) : Comment.create(payload)
      call
        .then((comment) => {
          Toaster.success(this.$t('js.generic.successfully_saved'))
          this.$emit('saved', comment)
          this.inputs = this.fillInputs()
        })
        .catch((errors) => {
          Toaster.error(this.$t('js.generic.failed_to_save'))
          this.errors = errors
        })
        .then(() => { this.loading = false })
    },
  },
  watch: {
    comment () {
      this.inputs = this.fillInputs()
    },
  },
}
</script>
